/**
 * SAP CONFIDENTIAL 
 *
 * This software is confidential proprietary software licensed by SAP SE 
 * and is not to be used, duplicated or disclosed to anyone without the 
 * prior written permission of SAP. 
 *
 * (C) 2020 Copyright SAP SE.
 */
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'volumeBaseCodeFilter' })
export class VolumeBaseCodeFilterPipe implements PipeTransform {
	transform(items: any, args: any): any {
		// filter items array, items which match '"type == 'DIRECT' will be kept, false will be filtered out        
		if (items && items.length > 0) {
			let filteredItems = [];
			filteredItems = items.filter((item: any) => item.id && item.type == args);
			filteredItems.unshift({ code: '', name: '-- Select --', label: '-- Select --' });
			return filteredItems;
		}
	}
}

@Pipe({ name: 'volumeMetricTypeCodeFilter' })
export class VolumeMetricTypeCodeFilterPipe implements PipeTransform {
	transform(items: any[], args: any[]): any {
		return items.filter(item => item.id && item.metricEvaluationType.id == args);
	}
}

@Pipe({ name: 'volumeSubTypeCodeFilter' })
export class VolumeSubTypeCodeFilterPipe implements PipeTransform {
	transform(items: any, args: any): any {
		return items.filter((item: any) => item.id && item.subType == args);
	}
}

@Pipe({ name: 'volumeSubTypeCodeFilterVW' })
export class VolumeSubTypeCodeFilterVWPipe implements PipeTransform {
	transform(items: any, args: any): any {
		return items.filter((item: any) => item.id && ((item.subType == args) && item.baseValue !== ''));
	}
}

@Pipe({ name: 'volumeTypeCodeFilter' })
export class VolumeTypeCodeFilterPipe implements PipeTransform {
	transform(items: any, args: any): any {
		return items.filter((item: any) => (item.volumeType == args) && (item.operation !== 'Delete') && (item.id));
	}
}

@Pipe({ name: 'titleByLeastRankFilter' })
export class TitleByLeastRankFilterPipe implements PipeTransform {
	transform(items: any[], args: any[]): any {
		return items.filter(item => item.id && (item.rank >= args));
	}
}